import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {

    // 查询列表数据
    page({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/lecturerReport/page`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    
    expotrtTable({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: '/lecturerReport/regionalReportExport',
            data: params,
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
    // 获取大区下拉数据
    getAreaList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/regionalReport/getOrg`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
};
